"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = "\n  button,\n  input,\n  select,\n  textarea {\n    font: inherit;\n  }\n";
exports["default"] = _default;